import { IEventCashFlowForm } from 'components/organisms/forms/event-cash-flow/EventCashFlowForm';
import { IEventIncomeResponse, IEventCostResponse } from 'services/events/types';

export const eventCashFlowQueryToForm = (
  eventCashFlowQuery: IEventIncomeResponse | IEventCostResponse,
  type: 'income' | 'cost'
): IEventCashFlowForm => {
  if (type === 'income') {
    const income = eventCashFlowQuery as IEventIncomeResponse;
    return {
      eventId: income.eventId,
      name: income.incomeName,
      tax: income.tax,
      amountGross: income.amount.grossAmount,
      amountNet: income.amount.netAmount,
      fileUrl: null,
    };
  } else {
    const cost = eventCashFlowQuery as IEventCostResponse;
    return {
      eventId: cost.eventId,
      name: cost.costName,
      tax: cost.tax,
      amountGross: cost.amount.grossAmount,
      amountNet: cost.amount.netAmount,
      fileUrl: null,
    };
  }
}; 